import { IGrupoRentabilidadeRef } from '../../domains/core/settings/grupos-rentabilidade/interfaces/grupo-rentabilidade.interface';
import { IItemPublicoAlvo } from '../../domains/product/itens/interfaces/item-publico-alvo.interface';
import type { IDynamicFormResponse } from '../../domains/shared/components/dynamic-form/interfaces/dynamic-form-response.interface';
import { BaseEntity } from '../../models';
import { Integracao } from '../integracao';
import { ItemFamilia } from '../item-familia';
import { ItemLinha } from '../item-linha';
import { ItemMarca } from '../item-marca';
import { ItemTipo } from '../item-tipo';
import { ItemUnidade } from '../item-unidade';
import { LinhaProducao } from '../linha-producao';
import { Mercado } from '../mercado';
import { NaturezaVenda } from '../natureza-venda';
import { Pessoa } from '../pessoa';
import { UnidadeNegocio } from '../unidade-negocio';
import { ItemClassificacao } from './classificacao';
import { ItemCustos } from './custos';
import { ItemEstadoImposto } from './estado-imposto';
import { ItemGrupo } from './grupo/item-grupo';
import { itemSituacaoAtivo } from './item-situacao';
import { ItemSubgrupo } from './subgrupo/item-subgrupo';

export interface ITag {
	id: number;
	nome: string;
	descricao: string;
}

export interface ITags {
	id: number;
	createdAt: string;
	idUsuarioCreated: number;
	idItem: number;
	idTag: number;
	tag: ITag;
}

export class Item implements BaseEntity, ItemCustos {
    readonly id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    cadastro: number;
    situacao: number;
    dataCadastro: Date;
    idPessoa: number;
    pessoa: Pessoa;
    idItemUnidade: number;
    unidade: ItemUnidade;
    idGrupoRentabilidade: number;
    grupoRentabilidade: IGrupoRentabilidadeRef;
    idItemGrupo: number;
    itemGrupo: ItemGrupo;
    idItemSubgrupo: number;
    itemSubgrupo: ItemSubgrupo;
    idItemFamilia: number;
    itemFamilia: ItemFamilia;
    idItemLinha: number;
    itemLinha: ItemLinha;
    idItemMarca: number;
    itemMarca: ItemMarca;
    idItemTipo: number;
    itemTipo: ItemTipo;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idLinhaProducao: number;
    linhaProducao: LinhaProducao;
    idNaturezaVenda: number;
    naturezaVenda: NaturezaVenda;
    idMercado: number;
    mercado: Mercado;
    quantidadeCaixaEmbarque: number;
    percComissao: number;
    fatorMultiplicadorKg: number;
    fatorConversao: number;
    classificacoesNome: string;

    // Classificações
    classificacoes: ItemClassificacao[];

    // Custos
    custoVariavel: number;
    custoFixo: number;
    custoProducao: number;
    despesaOperacional: number;
    percRoyalties: number;

    // Impostos
    percAliquotaIpi: number;
    estadosImpostos: ItemEstadoImposto[];

    // DVVs (override do item; null = herda da empresa, 0 = override que zera)
    percDvvAliquotaPis: number | null;
    percDvvAliquotaCofins: number | null;
    percDvvMarketing: number | null;
    percDvvDespesaAdministrativa: number | null;
    percDvvPerdaDevolucao: number | null;
    percDvvFrete: number | null;
    percDvvOutros: number | null;

    // Pesos
    pesoBruto: number;
    pesoLiquido: number;

    // Integração ERP
    codigoIntegracaoErp: string;
    codigoIntegracaoErpAnterior: string;
    idIntegracaoErp: number;
    integracaoErp: Integracao;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    // PLM
    nucleoPLM: number;
    fasePLM: number;
    cicloPLM: number;
    tipoConfiguracao: number;
    tipoEstrategicoPLM: number;
    dataPesquisaPLM: Date;
    dataDesenvolvimentoPLM: Date;
    dataGoToMarketPLM: Date;
    dataNascimentoPLM: Date;
    dataEncerramentoPLM: Date;
    idClassificacaoPLMRAP: number;
    idClassificacaoPLMRAR: number;
    publicosAlvo: IItemPublicoAlvo[];
    idDNAPLM: number;
    taxaAdocaoPLM: number;
    pesoMedioMaturacaoPLM: number;
    taxaMaturacaoNascimentoPLM: number;
    taxaMaturacaoCrescimentoPLM: number;
    taxaMaturacaoFortalecimentoPLM: number;
    taxaMaturacaoMaturidadePLM: number;

    // tags
    tags: any[];

    formSchema?: IDynamicFormResponse;

    // Atributos Auxiliares
    dataUltimoFaturamento: Date;
    unidadeNegocioHabilitarComprimentosItensPedidos: boolean;

    constructor() {
        this.situacao = itemSituacaoAtivo.id;
        this.dataCadastro = new Date();
        this.classificacoes = [];
        this.estadosImpostos = [];
    }
}
